export const V4SearchEntity = {Devices: 'devices', Sites: 'sites', Beacons: 'beacons'};

// Per type; the API allows 100 and has no paging.
export const V4_SEARCH_LIMIT = 50;

const MAX_BYTES = 256;

export const V4_ALL_ACCOUNTS = 'all-accounts';

const lc = id => String(id ?? '').toLowerCase();

// The API counts UTF-8 bytes, not characters.
export function v4SearchTooLong(term) {
    let bytes = 0;
    for (const char of term || '') {
        const code = char.codePointAt(0);
        bytes += code < 0x80 ? 1 : code < 0x800 ? 2 : code < 0x10000 ? 3 : 4;
    }
    return bytes > MAX_BYTES;
}

// owner -> its matched ids, lower-cased; owners outside `owners` are dropped.
export function groupV4SearchRefs(refs, owners) {
    const groups = new Map();
    (refs || []).forEach(ref => {
        if (!ref?.id || !ref?.owner || !owners.has(lc(ref.owner))) return;
        if (!groups.has(ref.owner)) groups.set(ref.owner, new Set());
        groups.get(ref.owner).add(lc(ref.id));
    });
    return groups;
}

export const isV4SearchMatch = (ids, row) => ids.has(lc(row?.get?.('uuid') || row?.get?.('id')));

export function sortBySearch(rows, refs) {
    const rank = new Map((refs || []).map((ref, i) => [lc(ref?.id), i]));
    const at = row => rank.get(lc(row?.get?.('uuid') || row?.get?.('id'))) ?? Infinity;
    return [...rows].sort((a, b) => at(a) - at(b));
}

export const v4AllAccountsItem = t => ({
    value: V4_ALL_ACCOUNTS,
    label: t('allAccounts', 'All accounts'),
    group: t('search'),
    object: {path: '', depth: 0, manager: true, root: true},
});
